<template>
  <div class="main-container">
    <div class="main-content-wrap">
      <div class="main-content-pannel">
        <option-menu class="no-bg no-border">
          <div class="content-title-wrap">
            <div class="main-content-title">Role Admin</div>
            <div class="main-content-menu">
              <div class="searchbox">
                <label for="roleFilter">
                  <i
                    v-if="!filterTxt"
                    class="material-icons-outlined align-middle"
                    >search</i
                  >
                  <i
                    v-else
                    @click="onQuickFilterChanged"
                    class="material-icons-outlined align-middle"
                    >clear</i
                  >
                </label>
                <input
                  id="roleFilter"
                  type="text"
                  @keyup="onQuickFilterChanged"
                  :value="filterTxt"
                  placeholder="Search"
                />
              </div>
              <button
                class="btn primary"
                href="javascript:void(0);"
                @click="addRole()"
                :class="{ active: editOpen == 1 }"
                title="Add Project"
              >
                <i class="material-icons-outlined align-middle">add</i>
                Add Role
              </button>
            </div>
          </div>
        </option-menu>
        <div class="main-bg p-0 m-t-0 m-b-0">
          <ag-grid-vue
            style="width: 100%; height: calc(100vh - 201px)"
            class="ag-theme-material"
            :gridOptions="gridOptions"
            :columnDefs="columnDefs"
            @column-resized="onColumnResized"
            @first-data-rendered="onFirstDataRendered"
            @grid-size-changed="onFirstDataRendered"
            :rowData="rowData"
          ></ag-grid-vue>
        </div>
      </div>
      <transition name="edit-pannel">
        <edit-pannel v-model="editOpen" @input="closeEditPannel" title>
          <PanelRole
            ref="addRole"
            v-if="editOpen == 1"
            :type="editType"
            :email="editEmail"
            :roles="editRoles"
            :uid="editUid"
            :submitLoading="rollSubmitLoading"
            @buttonClick="saveRole"
          ></PanelRole>
          <PanelRole
            ref="editRole"
            v-if="editOpen == 2"
            :type="editType"
            :email="editEmail"
            :roles="editRoles"
            :uid="editUid"
            :submitLoading="rollSubmitLoading"
            @buttonClick="saveRole"
          ></PanelRole>
        </edit-pannel>
      </transition>
    </div>
  </div>
</template>


<script>
import EditPannel from "@/components/EditPannel.vue";
import OptionMenu from "@/components/OptionMenu.vue";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/css/ag-grid.scss";
import { httpGet } from "@/http/http";
import PanelRole from "@/components/admin/roleAdmin/PanelRole.vue";
import GridActions from "@/components/admin/roleAdmin/GridActions.vue";
import GridDropdownMenu from "@/components/admin/roleAdmin/GridDropdownMenu.vue";

export default {
  props: ["editOpenTitle"],
  data() {
    return {
      filterTxt: "",
      gridOptions: {},
      columnDefs: null,
      rowData: [],
      editOpen: false,
      editType: null,
      editEmail: null,
      editRoles: null,
      editUid: null,
      rollSubmitLoading: false,
      dd: {
        index: null,
        el: null,
        isOpen: false,
      },
    };
  },
  components: {
    EditPannel,
    OptionMenu,
    AgGridVue,
    PanelRole,
    GridActions,
    GridDropdownMenu,
  },
  beforeMount() {
    this.createColumnDefs();
    this.createRowData();
  },
  created: function () {
    this.$EventBus.$on("globalClick", (event) => {
      this.hideAgDropdown(event);
    });
    setTimeout(() => {
      this.enableSetLocal = true;
    }, 3000);
  },
  watch: {
    editOpenTitle: function (val) {
      this.editOpen = val;
    },
  },
  methods: {
    refreshRowData: function () {
      this.gridOptions.api.setRowData(this.rowData);
    },
    saveRole: function (email, roles, password, sendEmail) {
      const saveEmail = email;
      const saveRoles = roles;
      const saveType = this.editType;
      this.rollSubmitLoading = true;
      httpGet("add_role", {
        email: email,
        roles: roles,
        password: password,
        sendEmail: sendEmail,
      })
        .then((response) => {
          if (response.ok) {
            this.editOpen = false;
            this.updateRowData(response.data, saveEmail, saveRoles);
            this.$toasted.global.toast_success({ message: "save success" });
          } else {
            this.$toasted.global.toast_error({ message: "save error" });
          }
        })
        .finally(() => {
          this.rollSubmitLoading = false;
        });
    },
    addRole: function () {
      this.editEmail = "";
      this.editRoles = [];
      this.editType = "add";
      this.editUid = null;
      this.openEditPannel(1, "Add Role", true);
    },
    editRole: function (data) {
      if (this.editOpen == 2 && this.editUid == data.uid) {
        this.openEditPannel(false, "Edit Role", false);
        return;
      }
      this.editEmail = data.email;
      this.editRoles = data.roles;
      this.editType = "edit";
      this.editUid = data.uid;
      this.openEditPannel(2, "Edit Role", false);
    },
    deleteRole: function (data) {
      if (confirm("do you want to delete?")) {
        const uid = data.uid;
        const email = data.email;
        httpGet("delete_role", { uid, email }).then((response) => {
          if (response.ok) {
            if (this.editUid == uid) {
              this.editOpen = false;
            }
            this.updateDeleteRowData(uid);
            this.$toasted.global.toast_success({ message: "delete success" });
          } else {
            this.$toasted.global.toast_error({ message: "delete error" });
          }
        });
      }
    },
    // filter
    onQuickFilterChanged(event) {
      this.filterTxt = event.target.value;
      this.gridOptions.api.setQuickFilter(event.target.value);
    },
    createColumnDefs: function () {
      this.gridOptions = {
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        sideBar: false,
        enableCellTextSelection: true,
        pagination: true,
        paginationPageSize: 9,
        paginationNumberFormatter: function (params) {
          return "[" + params.value.toLocaleString() + "]";
        },
      };
      this.columnDefs = [
        { headerName: "EMAIL", field: "email", width: 220 },
        { headerName: "ROLES", field: "roles", width: 200 },
        {
          headerName: "ACTIONS",
          field: "actions",
          width: 180,
          cellClass: "overflow-visible",
          cellRendererFramework: "GridDropdownMenu",
          sortable: false,
          filter: false,
          rowGroup: false,
        },
      ];
    },
    createRowData: function () {
      httpGet("get_user_roles").then((response) => {
        if (response.ok) {
          this.rowData = response.data;
          this.rowData.forEach((item, index) => {
            item.rowindex = index;
            item.ddOpen = false;
          });
          this.refreshRowData();
        }
      });
    },
    updateRowData: function (uid, email, roles) {
      if (this.rowData) {
        let index;
        for (const i in this.rowData) {
          if (this.rowData[i].uid == uid) {
            index = i;
            break;
          }
        }
        if (index === undefined) {
          this.rowData.push({
            uid,
            email,
            roles,
            ddOpen: false,
          });
        } else {
          this.rowData[index] = {
            uid,
            email,
            roles,
          };
        }
        this.refreshRowData();
      }
    },
    updateDeleteRowData: function (uid) {
      if (this.rowData) {
        let index;
        for (const i in this.rowData) {
          if (this.rowData[i].uid == uid) {
            index = i;
            break;
          }
        }
        if (index !== undefined) {
          this.rowData.splice(index, 1);
        }
        this.refreshRowData();
      }
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    // edit pannel: control open which component
    openEditPannel: function (action, title, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        this.emitEditPannel(title);
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
      this.emitEditPannel(title);
    },
    closeEditPannel: function () {
      this.editOpen = false;
      this.emitEditPannel();
    },
    emitEditPannel: function (title) {
      const param = {
        title: title,
        editOpen: this.editOpen,
      };
      this.$emit("openEditPannelTitle", param);
    },
    openCurrentAgDropdown: function (item, el) {
      if (this.dd.isOpen) {
        this.$set(this.rowData[this.dd.index], "ddOpen", false);
      }
      this.dd.isOpen = item.ddOpen;
      this.dd.index = item.rowindex;
      this.dd.el = el;
      this.$set(this.rowData[item.rowindex], "ddOpen", item.ddOpen);
      this.refreshRowData();
    },
    hideAgDropdown: function (e) {
      if (this.dd.el && !this.dd.el.contains(e.target)) {
        this.hideCurrentAgDropdown();
      }
    },
    hideCurrentAgDropdown: function () {
      this.$set(this.rowData[this.dd.index], "ddOpen", false);
      this.dd.isOpen = false;
      this.refreshRowData();
    },
  },
};
</script>
